if (typeof window.ENV != 'undefined' && window.ENV == 'prod' && typeof window.gtag != 'undefined') {
    $('#contact-form').submit(function () {
        window.gtag('event', 'landing.contacts.form', {
            'event_label': 'contacts.form.submit',
            'event_category': 'landing'
        });
    });
}